export function DiningOptionController(cartDisplayService, ORDER_TYPES) {
    'ngInject';
    var vm = this;
    vm.makePickup = makePickup;
    vm.makeDelivery = makeDelivery;
    vm.cartDisplay = {};
    activate();

    ///------------------------

    function chooseOption(enable, diningOption) {
        if (enable && cartDisplayService.displayData.diningOption !== diningOption) {
            cartDisplayService.updateDiningOption(diningOption);
        }
    }

    function makePickup() {
        chooseOption(vm.cartDisplay.enablePickup, ORDER_TYPES.TAKE_OUT);
    }

    function makeDelivery() {
        chooseOption(vm.cartDisplay.enableDelivery, ORDER_TYPES.DELIVERY);
    }

    function setCartDisplaydata() {
        vm.cartDisplay = cartDisplayService.displayData;
    }

    function activate() {
        cartDisplayService.getDisplayData()
            .finally(setCartDisplaydata);
    }
}
